import { render, staticRenderFns } from "./HomeFrontDoorCard.vue?vue&type=template&id=b4b4fad2"
import script from "./HomeFrontDoorCard.vue?vue&type=script&lang=js"
export * from "./HomeFrontDoorCard.vue?vue&type=script&lang=js"
import style0 from "./HomeFrontDoorCard.vue?vue&type=style&index=0&id=b4b4fad2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports